// extracted by mini-css-extract-plugin
export default {"colorBorder":"_1jfDEnUMc4953qXV1OZ0NK","dropdownIcon":"_31GoGu633tF-cGgFE_RBkJ"};